export default {"src":"/_next/static/media/cart.5bb4bfb7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};